module.exports = __webpack_public_path__ + "img/ac8.8a9a62c0.png";